import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

export type SectionId = 'overview' | 'company' | 'jobDetails';

export interface DesktopSidebarTabsProps {
  activeSection: SectionId;
  /** Optional; section is synced from hash and scroll observer when using hash links */
  onSectionChange?: (section: SectionId) => void;
  brandColor?: string;
  useBrandColor?: boolean;
}

const DEFAULT_BRAND_GREEN = '#10b981';

export const DesktopSidebarTabs: React.FC<DesktopSidebarTabsProps> = ({
  activeSection,
  onSectionChange,
  brandColor,
  useBrandColor = false,
}) => {
  const intl = useIntl();
  const effectiveBrandColour = brandColor || DEFAULT_BRAND_GREEN;

  const tabs = [
    { 
      id: 'overview' as const, 
      label: 'jobDetailPage.section.overview', 
      defaultLabel: 'Overview', 
      description: 'Tab label for job overview section' 
    },
    { 
      id: 'company' as const, 
      label: 'jobDetailPage.section.company', 
      defaultLabel: 'Company Information', 
      description: 'Tab label for company information section' 
    },
    { 
      id: 'jobDetails' as const, 
      label: 'jobDetailPage.section.jobDetails', 
      defaultLabel: 'Job Details', 
      description: 'Tab label for detailed job requirements section' 
    },
  ];

  return (
    <div className="w-48 flex-shrink-0">
      <div className="sticky top-6 space-y-1">
        {tabs.map((tab) => (
          <a
            key={tab.id}
            href={`#${tab.id}`}
            className={`w-full text-left px-5 py-3.5 rounded-2xl transition-colors transition-transform duration-200 block ${
              activeSection === tab.id
                ? 'bg-gray-100/90 dark:bg-gray-700/90 text-gray-900 dark:text-white font-semibold shadow'
                : 'text-gray-500 dark:text-gray-400 hover:bg-gray-50/60 dark:hover:bg-gray-800/60 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
            style={activeSection === tab.id ? { borderLeft: `4px solid ${useBrandColor ? effectiveBrandColour : DEFAULT_BRAND_GREEN}` } : {}}
          >
            <FormattedMessage id={tab.label} defaultMessage={tab.defaultLabel} />
          </a>
        ))}
      </div>
    </div>
  );
};
